































import { Vue, Component, Prop, Model } from 'vue-property-decorator';

import BaseToggle from '@/components/checkbox/BaseToggle.vue';
import BaseSelect from '@/components/select/BaseSelect.vue';
import TimepickerPopup from '@/components/time-picker/TimepickerPopup.vue';

import { ScheduleDay } from './types';
import { SelectItem, SelectValue } from '@/components/select/types';
import { Weekday, ISOTime } from '@/utils/date/types';

const DEFAULT_FROM_TIME = '09:00';
const DEFAULT_TO_TIME = '20:00';

export const defineEmptyScheduleDay =(weekday: Weekday): ScheduleDay => ({
    weekday,
    enabled: true,
    hidden: true,
    from: DEFAULT_FROM_TIME,
    to: DEFAULT_TO_TIME,
    clinic: null,
});

@Component({
    components: {
        BaseToggle,
        BaseSelect,
        TimepickerPopup,
    },
})
export default class ScheduleDayField extends Vue {
    // using ScheduleDay as a type here breaks the component, it becomes undefined in FormScheduleEdit, have no idea why
    @Model('update:day', { required: true }) day!: any
    @Prop({ required: true }) weekname!: string 
    @Prop({ default: () => [] }) clinics!: SelectItem[]
    @Prop({ default: false }) shouldShowClinics!: boolean

    get enabled() {
        return this.day.enabled;
    }

    set enabled(enabled) {
        this.updateDay('enabled', enabled);
    }

    get from() {
        return this.day.from;
    }

    set from(from: ISOTime) {
        this.updateDay('from', from);
    }

    get to() {
        return this.day.to;
    }

    set to(to: ISOTime) {
        this.updateDay('to', to);
    }

    get clinic() {
        return this.day.clinic;
    }

    set clinic(clinic: SelectValue) {
        this.updateDay('clinic', clinic);
    }

    updateDay(field: keyof ScheduleDay, value: any) {
        const day: ScheduleDay = {
            ...this.day,
            [field]: value,
        };

        this.$emit('update:day', day);
    }
}
